exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-44a7be2f]{font-size:16px}input[data-v-44a7be2f]{border:0;border-bottom:1px solid;padding-left:6px}.border-bottom[data-v-44a7be2f]{display:inline-block;border-bottom:1px solid;padding-left:5px;max-height:28px;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-44a7be2f","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/medDoc/parts/addOrEditXygl.vue
// module id = kY9L
// module chunks = 0